import React, {useContext, useEffect, useRef} from "react";
import {CartContext} from "@contexts/Cart.jsx"

// The <shipping-estimate> element needs Liquid-rendered data (metaobjects, per-line-item metafields) that this
// client-side drawer has no way to produce itself, so it's fetched via Shopify's Sections Rendering API instead
// and dropped in as raw HTML. The already-registered custom element (see src/main.js) upgrades itself once its
// markup lands in the document, same as if it had been rendered by Liquid to begin with.
export default () => {
  const {cart} = useContext(CartContext);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!cart) return;

    fetch(`${window.location.pathname}?sections=shipping-estimate`)
      .then((response) => response.json())
      .then((data) => {
        if (containerRef.current) {
          containerRef.current.innerHTML = data['shipping-estimate'];
        }
      })
      .catch((e) => console.error('[ProductCustomizerShippingEstimate] could not load shipping estimate section', e));
  }, [cart]);

  return <div ref={containerRef}></div>;
}
